import React from "react";
import "./Contact.css";
import ConnectWithUs from '../../common_components/ConnectWithUs'
import Header from '../../common_components/Header';
import Footer from "../../common_components/Footer";

import instaimg from "../../assets/img/instagram.png";
import facebookimg from "../../assets/img/facebook.png";
import linkedinimg from "../../assets/img/linkedin.png";
import twitterimg from "../../assets/img/twitter.png";
import youtubeimg from "../../assets/img/youtube.png";
import websiteImage from "../../assets/img/websiteImage.png";
function Contact() {
    return (
        <React.Fragment>
            <Header />
            <div className="main-content-page">
                <h1 className="container" style={{ color: "#650010" }}>
                    Contact Us
                </h1>

                <div className=" container contact-info">
                    <div className="left-info">
                        <b>
                            <p>Dr. M. Kalyan Chakravarthi</p>
                        </b>
                        <p>Assistant Director Alumni Relations</p>
                        <p>VIT AP Alumni Association (VITAAP)</p>
                        <p>Vellore Institute Technology (VIT AP)</p>
                        <p>Vijayawada 522237</p>
                        <p>Andhra Pradesh India</p>
                        <p>Phone : 0863 237 0444</p>
                        <p>Email id: alumni@vitap.ac.in</p>
                    </div>
                    <div className="right-info">
                        <img src="https://bindhumadhav.in/alumni/assets/img/faculty/kalyan2.jpg"></img>
                    <div className="social">
                        <a href="https://www.linkedin.com/in/kalyan-chakravarthi-bb6a3422/">
                        <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a href="mailto:kalyanchakravarthi.m@vitap.ac.in">
                            <i className="fas fa-envelope"></i>
                        </a>
                    </div>
                    </div>
                </div>
            </div>

            <div className="contact-map container">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.590154176305!2d80.49847891486411!3d16.496277688618374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f27d40f21c55%3A0x1490eacd54859850!2sVIT%20AP%20CAMPUS!5e0!3m2!1sen!2sin!4v1629440267154!5m2!1sen!2sin"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
            </div>

            <div className="container icon-text  row justify-content-center">
                <div className="box box1 col-3">

                    {/* <a href="tel:01234567890">01234 567 890</a> */}
                    <a href="tel:91-416-2202248">
                        <div className="top">
                            {/* <!-- <img src="assets/images/cellphoneringing.gif" className="img-fluid" alt="Caller phone GIF"> --> */}
                            <i className="fas fa-phone-square-alt"></i>
                        </div>
                        <div className="bottom">
                            <b className="imp" style={{color: "#650010"}}>Call us</b>
                            <p>+91-416-2202248</p>
                        </div>
                    </a>
                </div>

                <div className="box box2 col-3">
                    <a href="mailto:vitapalumni@gmail.com">
                        <div className="top">
                            {/* <!-- <img src="assets/images/mail.gif" className="img-fluid" alt="Mail sending GIF"> --> */}
                            <i className="fas fa-envelope"></i>
                        </div>
                            <div className="bottom">
                                <b className="imp" style={{color: "#650010"}}>Mail us</b>
                                <p>alumni@vitap.ac.in</p>
                            </div>
                    </a>
                </div>

                <div className="box box3 col-3">
                    <a href="https://www.google.com/maps/place/VIT-AP+University/@16.4962777,80.5006676,17z/data=!3m1!4b1!4m5!3m4!1s0x3a35f27d40f21c55:0x1490eacd54859850!8m2!3d16.4962777!4d80.5006676" target="blank">
                    <div className="top">
                        {/* <!-- <img src="assets/images/location.gif" className="img-fluid" alt="Location GIF"> --> */}
                        <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div className="bottom">
                        <b className="imp" style={{color: "#650010"}}>Reach us</b>
                        <p>VIT AP Block B, Alumni Affairs</p>
                    </div>
                    </a>
                </div>
            </div>

            <div className="container contact-form">
				<div className="contact-input">
					<h3>Write a message</h3>
					<form id="MessageForm">
						<input type="text" className="form-control" placeholder="Name *" id="MsgName" />
						<input type="text" className="form-control" placeholder="Email *" id="MsgEmail" />
						<textarea name="" rows="7" className="form-control" placeholder="Message *" id="MsgMessage"></textarea>
						<input className="form-control submit" type="submit" value="SUBMIT" />
					</form>
				</div>



				<div className="contact-social">
					<h3>Connect with us</h3>

                    <a href="https://vitapaa.netlify.app/">
                        <div className="sbox2 instagram">
                            <img src={websiteImage} className="img-fluid" alt="instagram icon" />
                            <p>Website</p>
                        </div>
                    </a>

                    <a href="https://www.instagram.com/test_alumni/">
                        <div className="sbox instagram">
                            <img src={instaimg} className="img-fluid" alt="instagram icon"/>
                            <p>Instagram</p>
                        </div>
                    </a>

                    <a href="https://www.facebook.com/vitap.coordalumni">
                        <div className="sbox facebook">
                            <img src={facebookimg} className="img-fluid" alt="Facebook icon" />
                            <p>Facebook</p>
                        </div>
                    </a>

                    <a href="https://www.linkedin.com/in/vitap-alumni-591849218/">
                        <div className="sbox linkedin">
                            <img src={linkedinimg} className="img-fluid" alt="Linkedin Icon" />
                            <p>Linked In</p>
                        </div>
                    </a>

					{/* <div className="sbox twitter">
						<img src={twitterimg} className="img-fluid" alt="twitter icon" />
						<p>Twitter</p>
					</div> */}
                    <a href="https://www.youtube.com/c/VITAP">
                        <div className="sbox youtube">
                            <img src={youtubeimg} className="img-fluid" alt="youtube icon" />
                            <p>Youtube</p>
                        </div>
                    </a>
				</div>
			</div>
            {/* <script src="assets/js/firebase/MessageForm.js"></script> */}
            <Footer />
        </React.Fragment>
    );

}
export default Contact;
